import React from 'react';
import {Button} from 'components';
import css from './tabs.module.scss';

export function Tabs({ className, ...props }) {
  return (
    <div {...props} className={css('tabs', className)} />
  );
}

Tabs.Tab = function Tab(props) {
  return (
    <Button className={css.tab} {...props} />
  );
}
